module.exports = __webpack_public_path__ + "img/signature.098bc271.png";